//
//
//
//
//
//
//

import { geet,loginGetCode } from '@/utils/loginIn.js'
import { phoneReg } from '@/utils/regular.js'

  export default {
    data() {
      return {
        // key: value
        timer:null,
        showTime:true,
        count:0,
      }
    },
    props: {
      phone: {
        type: [Number,String],
        default: ''
      },
      element: {
        type: Object,
        default: ()=>{
          return {}
        }
      }
    },
    methods: {
      async buttonClick() {
        // console.log('buttonClick')
        this.STATISTICS_CONFIG.insur_register_getcode_click()
        if(phoneReg.test(this.phone)) {
          const data = await geet()
          this.getCodeTime()
          // 倒计时
          this.$emit('buttonClick',data)
          // 发送验证码 
          await loginGetCode({phone:this.phone,sign_id:9,...data})
        }else{
          this.$toast('请输入正确的手机号')
        }
      },
      //验证码倒计时
      getCodeTime(){
        const TIME_COUNT = 60;
        if (!this.timer) {
        this.count = TIME_COUNT;
        this.showTime = false;
        this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
        } else {
            this.showTime = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
        }
      },
    },
  }
